import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

/**
 * Generated with generate-feature-flag-custom-hook.sh script
 * on 2026-06-02T01:11:27-0400.
 */
export function useHostEmailVerifiedCheck() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.VisitorManagementHostEmailVerifiedCheck,
    false
  );

  return Boolean(isEnabled);
}
